import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { ReduxAlert } from '../../shared/alert.component';
import SecondaryMenu from '../../menu/secondaryMenu.component';
import RateChangeWorkpaperGrid from './rateChangeWorkpaperGrid.component';

import { TaxRateChangePropType } from './propTypes';
import { submitRateChanges, fetchTaxRateChanges } from './store/actions';
import { currentPeriodSelector, userSelector } from '../../shared/store/selectors';
import { infoNotification } from '../../shared/store/notificationActions';
import { isGraphLoadingSelector, isSubmittingRowsSelector, taxRateChangesSelector } from './store/selectors';
import { UserWithoutActiveFlagPropTypes } from '../../shared/propTypes/users';
import { ClientIsLockedOverlay } from '../../shared/clientLocked/ClientLockedOverlay';
import { clientLockedMessages } from '../../shared/clientLocked/messages';
import './rateChangeWorkpaperPage.style.scss';

class RateChangeWorkpaperPage extends PureComponent {
  static propTypes = {
    fetchTaxRateChanges: PropTypes.func.isRequired,
    submitRateChanges: PropTypes.func.isRequired,
    currentPeriod: PropTypes.shape({
      name: PropTypes.string.isRequired,
      taxYear: PropTypes.string,
    }).isRequired,
    isGraphLoading: PropTypes.bool.isRequired,
    isSubmittingRows: PropTypes.bool.isRequired,
    taxRateChanges: PropTypes.arrayOf(TaxRateChangePropType).isRequired,
    user: UserWithoutActiveFlagPropTypes,
    showAlert: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { currentPeriod } = this.props;
    this.props.fetchTaxRateChanges(currentPeriod.name);
  }

  componentDidUpdate(prevProps) {
    const { currentPeriod } = this.props;
    const submittedRows = prevProps.isSubmittingRows && !this.props.isSubmittingRows;
    if (submittedRows) {
      this.props.fetchTaxRateChanges(currentPeriod.name);
    }
  }

  submitRateChanges = rateChanges => {
    const { currentPeriod, submitRateChanges } = this.props;
    submitRateChanges(rateChanges, currentPeriod.name, parseInt(currentPeriod.taxYear, 10));
  };

  render() {
    const { currentPeriod, showAlert, isGraphLoading, isSubmittingRows, taxRateChanges, user } = this.props;

    const rateChangeRows = taxRateChanges.map((rateChange, index) => ({
      ...rateChange,
      rateChangeId: index,
    }));

    return (
      <ClientIsLockedOverlay message={clientLockedMessages.RATE_CHANGE_WORKPAPER_PAGE}>
        <div className="view-rate-change-workpaper-page ag-grid-full-page-with-secondary-menu">
          <SecondaryMenu>
            <div className="current-period">{currentPeriod.name}</div>
          </SecondaryMenu>
          <div className="page">
            <div className="container-fluid page-content-container">
              <ReduxAlert/>
              <div className="row no-gutters">
                <div className="col">
                  <div className="d-flex flex-row justify-content-between">
                    <h5>Rate Change Workpaper</h5>
                  </div>
                </div>
              </div>
              <RateChangeWorkpaperGrid
                isLoading={isGraphLoading}
                isSubmittingRows={isSubmittingRows}
                rateChangeRows={rateChangeRows}
                submitRateChanges={this.submitRateChanges}
                user={user}
                showAlert={showAlert}
              />
            </div>
          </div>
        </div>
      </ClientIsLockedOverlay>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentPeriod: currentPeriodSelector(state),
    isGraphLoading: isGraphLoadingSelector(state),
    isSubmittingRows: isSubmittingRowsSelector(state),
    taxRateChanges: taxRateChangesSelector(state),
    user: userSelector(state),
  };
}

export default connect(
  mapStateToProps,
  {
    submitRateChanges,
    fetchTaxRateChanges,
    showAlert: infoNotification,
  }
)(RateChangeWorkpaperPage);
